// Angular
import { BrowserModule, Title } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';

// Angular in memory
// import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
// Perfect Scroll bar
// import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg-2';
// Env
import { environment } from '../environments';
// NGX Permissions
import { NgxPermissionsModule } from 'ngx-permissions';
// Copmponents
import { AppComponent } from './app.component';
// Modules
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { ThemeModule } from "./views/theme/theme.module";
// Partials
import { PartialsModule } from './views/partials/partials.module';
// Layout Services
import {
	DataTableService,
	KtDialogService,
	LayoutConfigService,
	LayoutRefService,
	MenuAsideService,
	MenuConfigService,
	MenuHorizontalService,
	PageConfigService,
	SplashScreenService,
	SubheaderService
} from './core/_base/layout';
// Auth
import { AuthModule } from './views/pages/auth/auth.module';
import { AuthService } from './core/auth/_services/auth.service';
// CRUD
import { HttpUtilsService, TypesUtilsService, CheckboxSelectUtilsService, ArrayUtilsService, ScrollUtilsService } from './core/_base/crud';
// Config
import { LayoutConfig } from './core/_config/layout.config';
import { MaterialModule } from './views/pages/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/es-AR';
import { ServiceWorkerModule } from '@angular/service-worker';
import { UpdateAlertComponent } from './views/models/update-alert/update-alert.component';
import { CommonPagesModule } from './views/pages/common/common-pages.module';
import { SharedModule } from './shared/shared.module';
import { NgxMaskModule } from 'ngx-mask';
import { RouterModule } from '@angular/router';
// import { ColorInputComponent } from './views/models/input/color-input/color-input.component';


registerLocaleData(localeAr);

// tslint:disable-next-line:class-name
// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
// 	wheelSpeed: 0.5,
// 	swipeEasing: true,
// 	minScrollbarLength: 40,
// 	maxScrollbarLength: 300,
// };

export function initializeLayoutConfig(appConfig: LayoutConfigService) {
	// initialize app by loading default demo layout config
	return () => {
		if (appConfig.getConfig() === null) {
			appConfig.loadConfigs(new LayoutConfig().configs);
		}
	};
}


@NgModule({
  declarations: [
    AppComponent,
    // UpdateAlertComponent,
    // ColorInputComponent,
  ],
	imports: [
		BrowserAnimationsModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		NgxPermissionsModule.forRoot(),
		PartialsModule,
		CoreModule,
		OverlayModule,
		AuthModule.forRoot(),
		TranslateModule.forRoot(),
		MatProgressSpinnerModule,
		InlineSVGModule.forRoot(),
		CommonPagesModule,
		ThemeModule,
		MaterialModule,
		ReactiveFormsModule,
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        SharedModule,
		NgxMaskModule.forRoot()
	],
	exports: [],
	providers: [
		AuthService,
		LayoutConfigService,
		LayoutRefService,
		MenuConfigService,
		PageConfigService,
		KtDialogService,
		DataTableService,
		SplashScreenService,
		// {
			// provide: PERFECT_SCROLLBAR_CONFIG,
			// useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		// },
		{
			// layout config initializer
			provide: APP_INITIALIZER,
			useFactory: initializeLayoutConfig,
			deps: [LayoutConfigService], multi: true
		},
		// template services
		SubheaderService,
		MenuHorizontalService,
		MenuAsideService,
		HttpUtilsService,
		TypesUtilsService,
		CheckboxSelectUtilsService,
		ArrayUtilsService,
		ScrollUtilsService,
		Title
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
